import { useState } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import API from "../../Api/axiosConfig";
// import MyButton from "../../Components/MyButton";
// import Can from "../../Components/Can";
import { useAuth } from "../../context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

function OwnerWithdrawl() {
  const { user, handleRefetch } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    value: "",
    cash_type: "",
    date: null,
    description: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedWithdrawl, setSelectedWithdrawl] = useState(null);

  const handleAdd = () => {
    setFormData({
      value: "",
      cash_type: "",
      date: null,
      description: "",
    });
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      await API.post("/owner-withdrawl", formData);
      console.log("تم تسجيل السحب بنجاح");
      setShowModal(false);
      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        console.log("فشل تسجيل السحب");
      }
    } finally {
      setLoading(false);
    }
  };
  const handleShowDetails = (withdrawl) => {
    setSelectedWithdrawl(withdrawl);
    setShowDetailsModal(true);
    // console.log(selectedWithdrawl);
  };

  const columns = [
    { header: "القيمة", accessor: "value" },
    {
      header: "الخزنة",
      accessor: (row) => (row.cash_type === "bank" ? "البنك" : "كاش"),
    },
    { header: "التاريخ", accessor: "date" },
    { header: "الوصف", accessor: "description" },
    {
      header: "الإجراءات",
      accessor: (row) => (
        <button
          className="btn btn-sm mx-1 extrabtn"
          title="عرض التفاصيل"
          onClick={() => handleShowDetails(row)}>
          <FontAwesomeIcon icon={faEye} color="white" />
        </button>
      ),
      hideOnPrint: true,
    },
  ];

  return (
    <div className="container mt-5">
      <Mytitle title="مسحوبات المالك" />
      {/* <Can permission="owner_withdrawl_create">

                <MyButton
                    text="إضافة سحب"
                    variant="success"
                    type="button"
                    className="mb-3"
                    onClick={handleAdd}
                />
            </Can> */}
      <ModalForm
        show={showModal}
        onClose={() => setShowModal(false)}
        title="إضافة سحب جديد"
        onSubmit={handleSubmit}
        loading={loading}
        mode="form"
        cash_type={formData.cash_type}>
        <MyInput
          label="القيمة"
          type="number"
          value={formData.value}
          onChange={(e) => setFormData({ ...formData, value: e.target.value })}
          error={errors.value?.[0]}
        />
        <MyInput
          as="select"
          value={formData.cash_type}
          formData={formData}
          onChange={(e) => {
            handleRefetch();
            setFormData({ ...formData, cash_type: e.target.value });
          }}
          options={[
            { value: "", label: "إختر الخزنة" },
            { value: "cash", label: "كاش" },
            { value: "bank", label: "بنك" },
          ]}
          error={errors.cash_type?.[0]}
        />
        <MyInput
          label="التاريخ"
          type="date"
          value={formData.date}
          onChange={(e) => setFormData({ ...formData, date: e.target.value })}
          error={errors.date?.[0]}
        />
        <MyInput
          label="الوصف"
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
          error={errors.description?.[0]}
        />
        {formData.cash_type === "cash" && (
          <div className="text-muted mb-2" style={{ direction: "rtl" }}>
            الرصيد المتاح في الكاش:{" "}
            <strong>{user?.data.last_cash_balance ?? 0}</strong>
          </div>
        )}
        {formData.cash_type === "bank" && (
          <div className="text-muted mb-2" style={{ direction: "rtl" }}>
            الرصيد المتاح في البنك:{" "}
            <strong>{user?.data.last_bank_balance ?? 0}</strong>
          </div>
        )}
      </ModalForm>
      <ModalForm
        show={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        title="تفاصيل السحب"
        mode="print">
        {selectedWithdrawl ? (
          <div className="p-3 bg-white text-dark" dir="rtl">
            <p>
              <strong>القيمة:</strong> {selectedWithdrawl.value}
            </p>
            <p>
              <strong>نوع السحب:</strong>{" "}
              {selectedWithdrawl.cash_type === "bank" ? "البنك" : "كاش"}
            </p>

            <p>
              <strong>الوصف:</strong> {selectedWithdrawl.description || "-"}
            </p>
            <p>
              <strong>تاريخ الحدث:</strong>{" "}
              {new Date(selectedWithdrawl.created_at).toLocaleString("ar-EG", {
                dateStyle: "short",
                timeStyle: "short",
              })}
            </p>
          </div>
        ) : (
          <p>لا توجد بيانات متاحة.</p>
        )}
      </ModalForm>
      <ModalForm
        show={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        title="تفاصيل العملية"
        mode="print">
        {selectedWithdrawl ? (
          <div className="p-3 bg-white text-dark" dir="rtl">
            <h5 className="text-center mb-5 ">
              مسحوبات المالك ({selectedWithdrawl.id})
            </h5>
            <p>
              <strong>القيمة:</strong> {selectedWithdrawl.value}
            </p>

            <p>
              <strong>التاريخ:</strong> {selectedWithdrawl.date}
            </p>
            <p>
              <strong>تاريخ الإنشاء:</strong>{" "}
              {new Date(selectedWithdrawl.created_at).toLocaleString("ar-EG", {
                dateStyle: "short",
                timeStyle: "short",
              })}
            </p>
            <p>
              <strong>الملاحظة:</strong> {selectedWithdrawl.note || "-"}
            </p>
          </div>
        ) : (
          <p>لا توجد بيانات متاحة.</p>
        )}
      </ModalForm>

      <MyTable
        resource="owner-withdrawl"
        columns={columns}
        refreshKey={refreshKey}
        dateFilter={{ field: "created_at", label: "تاريخ الإنشاء" }}
        title="مسحوبات المالك "
        button={{
          text: "إضافة سحب",
          onClick: handleAdd,
          variant: "success",
          permission: "owner_withdrawl_create",
        }}
      />
      <div
        style={{
          position: "relative",
          bottom: "0", // مسافة بسيطة من تحت
          left: "50%",
          transform: "translateX(-50%)", // يخلّي العنصر في وسط الشاشة بالظبط
          zIndex: 1000,
          marginTop: "40px",
          width: "fit-content",
        }}>
        <div
          className="text-center"
          style={{
            borderRadius: "15px",
            padding: "12px 35px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            minWidth: "300px",
            maxWidth: "90vw",
            backgroundColor: "#b19bd5",
            color: "#fff",
          }}>
          ! <strong>تنبيه : </strong> عند إجراء عملية مسحوبات لا يمكن الحذف او
          التعديل
        </div>
      </div>
    </div>
  );
}

export default OwnerWithdrawl;
